import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {Offering} from '@features/assignment/types.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {raise} from '@utilities/helpers.ts'
import {httpGetOfferings} from '@features/assignment/http/assignment.http'
import {captureException} from '@sentry/react'
import {z} from 'zod'
import {parseAxiosPromise} from '@/axiosInstance.ts'

export const useGetOfferings = (
    entityExternalId?: string,
    options?: Omit<UseQueryOptions<Offering[]>, 'queryFn' | 'queryKey'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.OFFERINGS, entityExternalId],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetOfferings({
                    urlParams: {entityExternalId: entityExternalId ?? raise('The code is not provided')},
                    params: {responseType: 'extended'}
                }),
                responseShape: z.array(Offering),
                onZodError: captureException
            }),
        ...options
    })
}
